module.exports = __webpack_public_path__ + "img/news.e921ec63.svg";